import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

interface GeoApiResponse {
  country: string;
}

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  constructor(private http: HttpClient) {}

  getUserCountry(): Observable<GeoApiResponse> {
    return this.http.get<GeoApiResponse>('https://get.geojs.io/v1/ip/country.json');
  }
}
